import Body from '@/components/Body'

export default (createElement) => {
  return createElement(Body)
}
